export enum AuthErrorEnum {
  InvalidUsernameOrPassword = 'INVALID_USERNAME_OR_PASSWORD',
  TwoFactorRequired = 'TWO_FACTOR_REQUIRED',
  InvalidOtp = 'INVALID_OTP',
  InvalidToken = 'INVALID_TOKEN',
  ExpiredToken = 'EXPIRED_TOKEN',
  AccountLocked = 'ACCOUNT_LOCKED',
  AccountNotConfirmed = 'ACCOUNT_NOT_CONFIRMED',
  Archived = 'ACCOUNT_ARCHIVED',
}
